export const ProblematicEmptyState = () => {
  return (
    <div className="py-16 text-center flex flex-col items-center gap-2 text-neutral-400 text-sm">
      <div className="w-12 h-12 rounded-full bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center text-emerald-400 text-xl font-bold mb-2">
        ✓
      </div>
      <p className="font-medium text-neutral-200">
        Проблем в кампаниях не обнаружено
      </p>
      <p className="text-xs text-neutral-400 max-w-md">
        Все кампании работают штатно, неэффективных площадок не зафиксировано.
      </p>
    </div>
  );
};
